exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@charset \"UTF-8\";\n/**\n* 申し込みステータス\n'contract_status' => [\n    '1000' => '新規',\n    '2000' => '申込',\n    '3000' => '保留',\n    '4000' => '否決',\n    '5000' => '架電待ち',\n    '6000' => '仮承認',\n    '7000' => '承認',\n    '8000' => '契約',\n    '9000' => 'キャンセル',\n]\n*/\n.table-th.is-error[data-v-098d25f6] {\n  background: #ffd8d8;\n}", ""]);

// exports
